import { Pattern } from "data/patterns";

interface Props {
  pattern: Pattern;
  backgroundColor: string;
}

export const PatternCard = ({ pattern, backgroundColor }: Props) => (
  <a
    href={pattern.patternUrl}
    className="block group relative overflow-hidden rounded-2xl lg:rounded-3xl transition-transform hover:scale-[1.02]"
    style={{ backgroundColor }}
  >
    <div className="aspect-square overflow-hidden">
      <img
        className="w-full h-full object-cover transition-transform group-hover:scale-105"
        src={pattern.imageUrl}
        alt={pattern.name}
        width={400}
        height={400}
        loading="lazy"
      />
    </div>
    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-primary/60 via-primary/30 to-transparent p-3 lg:p-4">
      <h3 className="text-white font-semibold text-sm lg:text-base line-clamp-1">
        {pattern.name}
      </h3>
      <div className="flex items-center gap-2 mt-1">
        <span className="text-white/80 text-xs lg:text-sm">
          {pattern.difficultyLabel}
        </span>
        <span className="text-white/60 text-xs">•</span>
        <span className="text-white/80 text-xs lg:text-sm">
          {pattern.timeLabel}
        </span>
      </div>
    </div>
  </a>
);
